import { useEffect } from "react";
import { useUiStore } from "@/stores/ui-store";
import { cn } from "@/lib/utils";
import { SidebarHeader } from "./SidebarHeader";
import { SidebarTabBar } from "./SidebarTabBar";
import { SidebarNav } from "./SidebarNav";
import { SidebarHealthStrip } from "./SidebarHealthStrip";
import { SidebarFooter } from "./SidebarFooter";

export function Sidebar() {
  const sidebarState = useUiStore((s) => s.sidebarState);
  const collapsed = sidebarState === "collapsed";

  // Keyboard shortcut: Ctrl+B / Cmd+B cycles sidebar states
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.ctrlKey || e.metaKey) && e.key === "b") {
        e.preventDefault();
        useUiStore.getState().cycleSidebarState();
      }
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  // Auto-hide sidebar on small screens
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    function handleChange(e: MediaQueryListEvent | MediaQueryList) {
      if (e.matches) {
        useUiStore.getState().setSidebarState("hidden");
      }
    }
    handleChange(mq);
    mq.addEventListener("change", handleChange);
    return () => mq.removeEventListener("change", handleChange);
  }, []);

  // Don't render when hidden
  if (sidebarState === "hidden") return null;

  return (
    <aside
      className={cn(
        "flex flex-col border-r border-sidebar-border bg-sidebar shadow-sidebar transition-all duration-200",
        collapsed ? "w-14" : "w-[280px]",
      )}
    >
      <SidebarHeader collapsed={collapsed} />
      <SidebarTabBar collapsed={collapsed} />
      <SidebarNav collapsed={collapsed} />
      <SidebarHealthStrip collapsed={collapsed} />
      <SidebarFooter collapsed={collapsed} />
    </aside>
  );
}
